// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.company-contacts-container {
  width: 273px;

  margin: 4px auto 15px;
  font-size: 12px;
  font-weight: 400;
  line-height: 130%;
}

.company-contacts-container .address {
  text-align: center;
}

.company-contacts-container .phone {
  margin-top: 2px;
  text-align: center;
}
.company-contacts-container .phone a {
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/components/components.company-contacts.css"],"names":[],"mappings":"AAAA;EACE,YAAY;;EAEZ,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,0BAA0B;AAC5B","sourcesContent":[".company-contacts-container {\n  width: 273px;\n\n  margin: 4px auto 15px;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 130%;\n}\n\n.company-contacts-container .address {\n  text-align: center;\n}\n\n.company-contacts-container .phone {\n  margin-top: 2px;\n  text-align: center;\n}\n.company-contacts-container .phone a {\n  text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
